import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import * as GoogleAPI from '../../utils/googleApiHelper';

class ContactPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      password: ''
    }

    this.changeHandler = this.changeHandler.bind(this);
    this.initMap = this.initMap.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.initMap();
    }, 500);

    window.scrollTo(0, 0);

  }

  initMap() {
    let options = {
      center: {
        lat: 34.04076231072783,
        lng: -118.2548779
      },
      zoom: 15
    }
    let storeIcon = {
      url: require("../../assets/images/icon.png"), // url
      scaledSize: new google.maps.Size(35, 35), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(17.5, 17.5) // anchor
    };
    this.map = new google.maps.Map(this.mapElement, {
      center: options.center,
      zoom: options.zoom,
      format: 'png',
      maptype: 'roadmap',
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#212121"
            }
          ]
        }, {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }, {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        }, {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#212121"
            }
          ]
        }, {
          "featureType": "administrative",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        }, {
          "featureType": "administrative.country",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }, {
          "featureType": "administrative.land_parcel",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }, {
          "featureType": "administrative.locality",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        }, {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#181818"
            }
          ]
        }, {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        }, {
          "featureType": "poi.park",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#1b1b1b"
            }
          ]
        }, {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#2c2c2c"
            }
          ]
        }, {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#8a8a8a"
            }
          ]
        }, {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#373737"
            }
          ]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#3c3c3c"
            }
          ]
        }, {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#4e4e4e"
            }
          ]
        }, {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        }, {
          "featureType": "transit",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        }, {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#3d3d3d"
            }
          ]
        }
      ]
    })

    this.marker = new google.maps.Marker({position: options.center, map: this.map});
    // let storeMarker = new google.maps.Marker({
    //       position: {
    //         'lat': 34.0407566,
    //         'lng': -118.2548668
    //       },
    //       icon: storeIcon,
    //       map: this.map
    //     });


  }

  render() {
    return (<div className="page contact-page">
      <div className="gmap-container">
        <div className="address-map" ref={(elem) => this.mapElement = elem}></div>
      </div>
      <div className="container">
        <h1 className="page-title">Get in touch</h1>
        <div className="row">
          <div className="col-lg-7">
            <h2>We'd love to hear from you.</h2>
            {/*<form onSubmit={this.contact}>
                <div className="row form-container">
                  <div className="col-md-12">
                    <label>Name *</label>
                  <input name="name" required onChange={this.changeHandler}/>
                  </div>
                  <div className="col-md-12">
                    <label>Email Address *</label>
                    <input type="email" required name="email" onChange={this.changeHandler}/>
                  </div>
                  <div className="col-md-6">
                    <label>Phone Number *</label>
                    <input name="phone" required type="tel" onChange={this.changeHandler}/>
                  </div>
                  <div className="col-md-12">
                    <label>Website</label>
                    <input name="website" required onChange={this.changeHandler}/>
                  </div>
                  <div className="col-md-12">
                    <label>Message</label>
                    <textarea name="message" required onChange={this.changeHandler}></textarea>
                  </div>
                  <div className="col-md-12">
                    <div className="form-footer">
                      {this.state.error
                        ? (
                          <p className="pull-left text-error">{this.state.error}</p>
                        )
                        : null}
                      <button type="submit" disabled={this.state.invalid} className="button button-block">Send</button>
                    </div>
                  </div>

                </div>
              </form>*/
            }
            <div className="info-row">
              <div className="info">
                <i className="fa fa-building-o icon"></i>
                <div className="content">
                  <p>Jasons Wine and Spirits<br/>828 s. Main Street,Los Angeles<br/>CA 90014</p>
                </div>
              </div>
            </div>
            <div className="info-row">
              <div className="info">
                <i className="fa fa-phone icon"></i>
                <div className="content">
                  <p>(213) 485-9463</p>
                </div>
              </div>
            </div>
            <div className="info-row">
              <div className="info">
                <i className="fa fa-envelope-o icon"></i>
                <div className="content">
                  <p>
                    <a href="mailto:info@jasonsliquor.com">info@jasonsliquor.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            {/*<h2>Get in touch</h2>
              <h3>we'd love to hear from you.</h3>
              <div className="info-row">
                <div className="info">
                  <i className="fa fa-building-o icon"></i>
                  <div className="content">
                    <p>Jasons Wine and Spirits<br />828 s. Main Street,Los Angeles<br />CA 90014</p>
                  </div>
                </div>
              </div>
              <div className="info-row">
                <div className="info">
                  <i className="fa fa-phone icon"></i>
                  <div className="content">
                    <p>(213) 485-9463</p>
                  </div>
                </div>
              </div>
              <div className="info-row">
                <div className="info">
                  <i className="fa fa-envelope-o icon"></i>
                  <div className="content">
                    <p><a href="mailto:info@jasonsliquor.com">info@jasonsliquor.com</a></p>
                  </div>
                </div>
              </div>*/
            }
            </div>
        </div>
      </div>
    </div>)
  }

  contact(e) {
    e.preventDefault();
  }

  changeHandler(e) {

    console.log("contact data change", e.target.value);
    const {contactData} = this.state;
    let newContactData = Object.assign({}, contactData);
    newContactData[e.target.name] = e.target.value;
    this.setState({
      contactData: newContactData
    }, () => {
      this.checkValidation()
    });

  }

  checkValidation() {
    // let newSignupData = Object.assign({}, this.state.signupData);
    // let invalid = true;
    // for (let i in newSignupData) {
    //   console.log(i, newSignupData[i]);
    //   if (newSignupData[i] != '') {
    //     invalid = false;
    //   } else {
    //     invalid = true
    //   }
    // }
    // console.log("is invalid", invalid, newSignupData);
    // this.setState({invalid})
  }

}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/containers/contact-us/ContactPage.js